module.exports = "/images/right-arrow.svg?5a7960e661492e47718ad31ca7b60af2";